import { useCallback, useState } from 'react'
import { checkErrorsCompensationAccruals } from './checkErrorsCompensationAccruals'
import { checkErrorsCompensationAccrualsFor } from './checkErrorsCompensationAccrualsFor'
import { checkErrorsCompensationInclude } from './checkErrorsCompensationInclude'
import { checkErrorsCompensationAccrualPeriod } from './checkErrorsCompensationAccrualPeriod'


export type Errors = Map<string, string>

const emptyErrors: Errors = new Map()

export function useCompensationErrors(accrualsShiftsAmount: number) {
  const [errors, setErrors] = useState<Errors>(emptyErrors)

  const resetErrors = useCallback(() => {
    setErrors(emptyErrors)
  }, [])

  const checkErrors = useCallback((formData: FormData) => {
    const err = new Map()

    checkErrorsCompensationAccruals(err, formData, accrualsShiftsAmount)
    checkErrorsCompensationAccrualsFor(err, formData)
    checkErrorsCompensationInclude(err, formData)
    checkErrorsCompensationAccrualPeriod(err, formData)

    if (err.size) {
      setErrors(err)
      return false
    }
    return true
  }, [accrualsShiftsAmount])

  return {
    errors,
    resetErrors,
    checkErrors,
  }
}
